import { Component, NgZone } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthService } from '../../services/auth.service';

import { TermsofusePage } from '../termsofuse/termsofuse';
import { PrivacypolicyPage } from '../privacypolicy/privacypolicy';
import { CookiesPage } from '../cookies/cookies';
import { LegalPage } from '../legal/legal';
import { TranslateService } from '@ngx-translate/core';
import { AppUtilities } from '../../app/app.utilities';
import { SignupEmailPage } from '../signup-email/signup-email';

@Component({
  selector: 'page-login-email',
  templateUrl: 'login-email.html'
})
export class LoginEmailPage {
  loginForm: FormGroup;
  resetForm: FormGroup;
  loginError: string;
  reset: boolean;

  terminosUso: boolean = false;
  public termsofusePage = TermsofusePage;
  public privacyPolicy = PrivacypolicyPage;
  public cookies = CookiesPage;
  public legalPage = LegalPage;

  constructor(
    private navCtrl: NavController,
    private auth: AuthService,
    fb: FormBuilder,
    private _translate: TranslateService,
    private ngZone: NgZone,
    public alertCtrl: AlertController,
    private utilities: AppUtilities
  ) {
    this.reset = false;
    this.loginForm = fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6)])],
      check: ['']
    });

    this.resetForm = fb.group({
      email: ['', Validators.compose([Validators.required, Validators.email])]
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad LoginEmailPage');
  }

  login() {
    if (this.terminosUso) {
      this.utilities.loading();
      let data = this.loginForm.value;

      if (!data.email) {
        this.utilities.loadingDismiss();
        return;
      }

      let credentials = {
        email: data.email,
        password: data.password
      };
      this.auth.signInWithEmail(credentials).then(
        response => {
          console.log(' data ', response);
          this.utilities.loadingDismiss();
        },
        error => {
          this.loginError = error.message;
          this.utilities.loadingDismiss();
        }
      );
    } else {
      var WARNING_TEXT_LOGIN = this._translate.instant('WARNING_TEXT_LOGIN');
      const alert = this.alertCtrl.create({
        subTitle: WARNING_TEXT_LOGIN,
        buttons: ['OK']
      });
      alert.present();
    }
  }

  signup() {
    this.navCtrl.push(SignupEmailPage);
  }

  updateValue() {
    console.log('Check box ' + this.terminosUso);
    this.ngZone.run(() => {
      this.terminosUso;
    });
  }

  goLogin() {
    this.loginError = null;
    this.reset = false;
  }

  goRestePW() {
    this.loginError = null;
    this.reset = true;
  }

  restePassword() {
    let data = this.resetForm.value;

    if (!data.email) {
      return;
    }

    var email = data.email;

    this.auth
      .resetPasswordWithEmial(email)
      .then(() => {
        //RESET_PW_TEXT
        var RESET_PW_TEXT = this._translate.instant('RESET_PW_TEXT');
        const alert = this.alertCtrl.create({
          subTitle: RESET_PW_TEXT,
          buttons: ['OK']
        });
        alert.present();
        this.reset = false;
        this.loginError = null;
      })
      .catch(error => {
        this.loginError = error.message;
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/login-email/login-email.ts